import React from 'react';

import { Button, Container, Stack, Typography } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

type LensAccessCheckErrorProps = {
  onRetry: () => void;
};

export default function LensAccessCheckError({ onRetry }: LensAccessCheckErrorProps) {
  return (
    <Container maxWidth="xl">
      <PageHeader title="askRichard" />
      <Stack alignItems="flex-start" spacing={2}>
        <Typography>We couldn&apos;t check your askRichard access. Please try again.</Typography>
        <Button onClick={() => onRetry()} variant="contained">
          Try again
        </Button>
      </Stack>
    </Container>
  );
}
